var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.745.808A.78.78 0 0 1 8.5.22h5a.78.78 0 0 1 .756.588l.684 2.698H21a.78.78 0 1 1 0 1.56h-.95l-1.606 19a.78.78 0 0 1-.778.714H4.334a.78.78 0 0 1-.777-.714l-1.606-19H1a.78.78 0 0 1 0-1.56h6.06L7.745.808ZM7.65 5.066h10.834L16.951 23.22H5.05L3.516 5.066h4.135Zm5.68-1.56H8.67l.438-1.726h3.786l.438 1.726ZM6.769 8.437a.78.78 0 0 1 .843.712l.834 9.857a.78.78 0 0 1-1.555.131L6.057 9.28a.78.78 0 0 1 .711-.843Zm8.465 0a.78.78 0 0 1 .712.843l-.834 9.857a.78.78 0 0 1-1.554-.131l.833-9.857a.78.78 0 0 1 .843-.712Zm-4.232-.003c.43 0 .78.35.78.78v9.857a.78.78 0 1 1-1.56 0V9.214c0-.43.349-.78.78-.78Z",
    fill: "#fff"
  })));
};
export default SvgTrash;